import React, { Component } from "react";
import { Row, Col, Table } from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import _ from "lodash";
import moment from 'moment';

import { getMessage } from "CONFIG/i18n";

import icBack from "ASSETS/Images/back.svg";

import { OPERATOR_STATUS_LIST } from "UTILS/Constants";
import { getBootstrapTableOptions } from "UTILS/Utility";

//Stylesheet
import "./SupportCenter.less";

class SupportCenter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalId: null,
    };
  }

  componentDidMount() {
    this.props.getAllOperators();
    this.props.getSupportCenterSessions();

    // Get all operator information and all support center meeting information 
    // every 30 seconds.
    this.state.intervalId = setInterval(() => {
      this.props.getAllOperators();
      this.props.getSupportCenterSessions();
    }, 1000 * 30);
  }

  componentWillUnmount() {
    // Clear the timer set when mounted.
    clearInterval(this.state.intervalId);
  }

  backYesHandle = () =>{
    this.props.backToMenu();
  }

  operatorStatusSort = (a, b, order) => {
    if (order === 'asc') {
      return OPERATOR_STATUS_LIST.indexOf(a.status) - OPERATOR_STATUS_LIST.indexOf(b.status);
    } else {
      return OPERATOR_STATUS_LIST.indexOf(b.status) - OPERATOR_STATUS_LIST.indexOf(a.status);
    }
  }

  render() {
    const operatorStatusCount = {};
    this.props.operatorList.forEach((operator) => {
      operatorStatusCount[operator.status] 
        = (operatorStatusCount[operator.status] || 0) + 1;
    })
    const responseCount = this.props.todaySessionCountList.all
      - this.props.todaySessionCountList.waiting
      - this.props.todaySessionCountList.abandoned;
    return(
      <>
        <div className="col-12 d-flex align-items-center backBtn pl-3 pt-2">
          <img 
            src={icBack} 
            className="pr-2 cursorPointer"
            onClick={this.backYesHandle} 
          />
          <span 
            className="cursorPointer" 
            onClick={this.backYesHandle}
          >
            {getMessage("BACK")}
          </span>
        </div>
        <Row className="supportCenterHeader">
          <Col className="col mr-3">
            <Table bordered={false} size="sm" className="organisationsList">
              <thead className="tableHeader">
                <tr>
                  <th className="tableRow" title={getMessage("CORRESPONDENCE")}>
                    {getMessage("CORRESPONDENCE")}
                  </th>
                  <th className="tableRow" title={getMessage("LEAVING")}>
                    {getMessage("LEAVING")}
                  </th>
                  <th className="tableRow" title={getMessage("WAITING")}>
                    {getMessage("WAITING")}
                  </th>
                  <th className="tableRow" title={getMessage("ABSENCE")}>
                    {getMessage("ABSENCE")}
                  </th>
                </tr>
              </thead>
              <tbody className="tableBody">
                <tr>
                  <td title={operatorStatusCount.CORRESPONDENCE || 0}>
                    {operatorStatusCount.CORRESPONDENCE || 0}
                  </td>
                  <td title={operatorStatusCount.LEAVING || 0}>
                    {operatorStatusCount.LEAVING || 0}
                  </td>
                  <td title={operatorStatusCount.WAITING || 0}>
                    {operatorStatusCount.WAITING || 0}
                  </td>
                  <td title={operatorStatusCount.ABSENCE || 0}>
                    {operatorStatusCount.ABSENCE || 0}
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
          <Col className="col">
            <Table bordered={false} size="sm" className="organisationsList">
              <thead className="tableHeader">
                <tr>
                  <th className="tableRow" title={getMessage("NUMBER_OF_INCOMING_CALLS")}>
                    {getMessage("NUMBER_OF_INCOMING_CALLS")}
                  </th>
                  <th className="tableRow" title={getMessage("NUMBER_OF_RESPONSES")}>
                    {getMessage("NUMBER_OF_RESPONSES")}
                  </th>
                  <th className="tableRow" title={getMessage("RESPONSE_RATE")}>
                    {getMessage("RESPONSE_RATE")}
                  </th>
                </tr>
              </thead>
              <tbody className="tableBody">
                <tr>
                  <td title={this.props.todaySessionCountList.all}>
                    {this.props.todaySessionCountList.all}
                  </td>
                  <td title={responseCount}>
                    {responseCount}
                  </td>
                  <td title={this.props.todaySessionCountList.all
                    ? `${Math.round(responseCount 
                        / this.props.todaySessionCountList.all * 100)}%`
                    : "-"
                  }>
                    {this.props.todaySessionCountList.all
                      ? `${Math.round(responseCount 
                          / this.props.todaySessionCountList.all * 100)}%`
                      : "-"
                    }
                  </td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>
        <Row className="operatorList">
          <Col>
            <div>{getMessage("OPERATOR_LIST")}</div>
            <BootstrapTable
              data={this.props.operatorList.map((operator) => {
                return { 
                  ...operator, 
                  fullName: `${operator.lastName} ${operator.firstName}` 
                }
              }).sort((a, b) => {
                return OPERATOR_STATUS_LIST.indexOf(a.status)
                  - OPERATOR_STATUS_LIST.indexOf(b.status);
              })}
              keyField="email"
              tableHeaderClass="tableHeader"
              tableBodyClass='tableBody'
              containerClass='organisationsList'
              bordered={false}
              options={getBootstrapTableOptions()}
              maxHeight='300px'
            >
              <TableHeaderColumn
                dataField='email'
                dataSort={true}
                dataFormat={(cell) => {
                  return <div className="nameEllipsis" title={cell}>{cell}</div>;
                }}
                width="15%"
              >
                {getMessage("ACCOUNT_ID")}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField='fullName'
                dataSort={true}
                dataFormat={(cell) => {
                  return <div className="nameEllipsis" title={cell}>{cell}</div>;
                }}
                width="15%"
              >
                {getMessage("OPERATOR")}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField='status'
                dataSort={true}
                dataFormat={(cell) => {
                  return (
                    <div className={`status ${cell}`} title={getMessage(cell)}>
                      {getMessage(cell)}
                    </div>
                  );
                }}
                width="17%"
                sortFunc={this.operatorStatusSort}
              >
                {getMessage("OPERATOR_STATUS")}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField='sessionName'
                dataSort={false}
                dataFormat={(cell) => {
                  return <div className="nameEllipsis" title={cell}>{cell}</div>;
                }}
                width="29%"
              >
                {getMessage("SESSION_NAME")}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField='sessionStartTime'
                dataSort={false}
                dataFormat={(cell, row) => {
                  if (cell && row.status === "CORRESPONDENCE") {
                    return (
                      <div  className="nameEllipsis" title={moment(cell).format('HH:mm:ss')}>
                        {moment(cell).format('HH:mm:ss')}
                      </div>
                    );
                  }
                }}
                width="12%"
              >
                {getMessage("INCOMING_CALL_TIME")}
              </TableHeaderColumn>
              <TableHeaderColumn
                dataField='sessionStartTime'
                dataSort={false}
                dataFormat={(cell, row) => {
                  if (cell && row.status === "CORRESPONDENCE") {
                    const displayTime 
                      = moment.utc(moment().diff(moment(cell))).format('HH:mm:ss');
                    return <div className="nameEllipsis" title={displayTime}>{displayTime}</div>;
                  }
                }}
                width="12%"
              >
                {getMessage("RESPONSE_TIME")}
              </TableHeaderColumn>
            </BootstrapTable>
          </Col>
        </Row>
        <Row className="supportCenterFooter">
          <Col xs={6} className="supportCenterFooterCol">
            <div className="waitingListContainer">
              <div className="d-flex justify-content-between">
                <div>{getMessage("WAITING_LIST")}</div>
                <div>
                  {getMessage("COUNT_MEETINGS",
                    { count: this.props.waitingSessionList.total })}
                </div>
              </div>
              <BootstrapTable
                data={this.props.waitingSessionList.sessions}
                keyField='id'
                tableHeaderClass="tableHeader"
                tableBodyClass='tableBody'
                containerClass='organisationsList'
                bordered={false}
                options={getBootstrapTableOptions()}
                maxHeight='200px'
              >
                <TableHeaderColumn
                  dataField='sessionName'
                  dataSort={false}
                  dataFormat={(cell) => {
                    return <div className="nameEllipsis" title={cell}>{cell}</div>;
                  }}
                  width="75%"
                >
                  {getMessage("SESSION_NAME")}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField='createTime'
                  dataSort={false}
                  dataFormat={(cell, row) => {
                    if (cell) {
                      const displayTime 
                        = moment.utc(moment().diff(moment(cell))).format('HH:mm:ss');
                      return (
                        <div className="nameEllipsis" title={displayTime}>
                          {displayTime}
                        </div>
                      );
                    }
                  }}
                  width="25%"
                >
                  {getMessage("WAITING_TIME")}
                </TableHeaderColumn>
              </BootstrapTable>
            </div>
          </Col>
          <Col xs={6} className="supportCenterFooterCol">
            <div className="abandonedListContainer">
              <div className="d-flex justify-content-between">
                <div>{getMessage("ABANDONED_CALLS")}</div>
                <div>
                  {getMessage("COUNT_MEETINGS",
                    { count: this.props.abandonedSessionList.total })}
                </div>
              </div>
              <BootstrapTable
                data={this.props.abandonedSessionList.sessions}
                keyField='id'
                tableHeaderClass="tableHeader"
                tableBodyClass='tableBody'
                containerClass='organisationsList'
                bordered={false}
                options={getBootstrapTableOptions()}
                maxHeight='200px'
              >
                <TableHeaderColumn
                  dataField='sessionName'
                  dataSort={false}
                  dataFormat={(cell) => {
                    return <div className="nameEllipsis" title={cell}>{cell}</div>;
                  }}
                  width="50%"
                >
                  {getMessage("SESSION_NAME")}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField='createTime'
                  dataSort={false}
                  dataFormat={(cell) => {
                    if (cell) {
                      return (
                        <div  className="nameEllipsis" title={moment(cell).format('HH:mm:ss')}>
                          {moment(cell).format('HH:mm:ss')}
                        </div>
                      );
                    }
                  }}
                  width="25%"
                >
                  {getMessage("INCOMING_CALL_TIME")}
                </TableHeaderColumn>
                <TableHeaderColumn
                  dataField='endTime'
                  dataSort={false}
                  dataFormat={(cell, row) => {
                    if (cell) {
                      const displayTime 
                        = moment.utc(moment(cell).diff(moment(row.createTime))).format('HH:mm:ss');
                      return <div className="nameEllipsis" title={displayTime}>{displayTime}</div>;
                    }

                  }}
                  width="25%"
                >
                  {getMessage("RING_TIME")}
                </TableHeaderColumn>
              </BootstrapTable>
            </div>
          </Col>
        </Row>
      </>
    )
  }
}

export default SupportCenter;